export const isValidUrl = (url: string) => {
  if (!url) return false;
  return /^https:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}/gi.test(
    url,
  );
};
